import React from 'react';
import '../css/App.css';
import ls from "local-storage";
import {withRouter} from "react-router";

class RightNav extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            name:props.name,
            nav_open:props.nav_open,
            navItems:[
                {
                    title:"پروفایل",
                    img:"nav_user.png",
                    url:"/profile",
                },
                {
                    title:"افزایش اعتبار",
                    img:"addcredit.png",
                    url:"/add_credit",
                },
                {
                    title:"پیام های من",
                    img:"message.png",
                    url:"/messages",
                },
                {
                    title:"آدرس های من",
                    img:"address.png",
                    url:"/address",
                },
                {
                    title:"پشتیبانی",
                    img:"nav_ticket.png",
                    url:"/profile",
                },
                {
                    title:"تغییر شهر",
                    img:"city.png",
                    url:"/city",
                },
            ],
            fontSize:ls.get("fontSize")
        };

        this.handleEvent = this.handleEvent.bind(this);
        this.handleRightNavClick = this.handleRightNavClick.bind(this);

    }
    componentWillReceiveProps(props) {
        this.setState(
            {nav_open:props.nav_open,fontSize:props.fontSize})
    }

    componentDidMount() {
        if(!ls.get("fontSize")){
            ls.set("fontSize",3);
            this.setState({fontSize:3});
        }
        window.addEventListener("click", this.handleEvent)
    }

    componentWillUnmount(){
        window.removeEventListener("click", this.handleEvent)
    }
    render() {
        let nav_class = "";
        if(this.state.nav_open)
            nav_class = "nav_open";

        let font = "متوسط";
        switch (this.state.fontSize) {
            case 1:font = "خیلی کوچک";break;
            case 2:font = "کوچک";break;
            case 3:font = "متوسط";break;
            case 4:font = "بزرگ";break;
            case 5:font = "خیلی بزرگ";break;
            default:font = "متوسط";break;
        }
        return (
            <div>
                <div className={"rightNav "+nav_class}>
                    <div className={"rightNameBox"}>
                        <p style={{textAlign:"Right",width:"100%",fontSize:"14px",color:"white",right:"20px",position:"relative"}}>{ls.get("user").fnamelname}</p>
                        <p style={{textAlign:"Right",width:"100%",fontSize:"14px",color:"white",right:"20px",position:"relative"}}>{ls.get("user").phone}</p>
                    </div>
                    <div className={"rightNavItems"}>
                        {this.generateItems()}
                        <hr style={{margin:"20px 0"}}/>
                        <div className={"rightNavItem"}>
                            <img className={"rightNavImg"} src={`${process.env.PUBLIC_URL}/assets/images/about.png`}/>
                            <p className={"rightNavTex"}>درباره ما</p>
                        </div>
                        <div className={"rightNavItem"} onClick={this.logout}>
                            <img className={"rightNavImg"} src={`${process.env.PUBLIC_URL}/assets/images/logout.png`}/>
                            <p className={"rightNavTex"}>خروج</p>
                        </div>
                        <div className={"rightNavItem"}>
                            <button id={"fontPlus"} onClick={this.props.plusFont}>+</button>
                            <div id={"fontText"}>{font}</div>
                            <button id={"fontMinus"} onClick={this.props.minusFont}>-</button>
                        </div>
                    </div>
                </div>
                <div className={"leftNav "+nav_class} id={"leftNav"}>
                </div>
            </div>
        );
    }



    logout= ()=>{
        ls.clear();
        this.props.history.push("/");
    };
    handleEvent = (event) => {
        if(event.target.id == "leftNav")
            this.props.offNave();
    };

    handleRightNavClick = (url) => {
        this.props.history.push(url);
    };

    generateItems(){
        return this.state.navItems.map((data)=>{
            return (
                <div className={"rightNavItem"} onClick={()=>{this.handleRightNavClick(data.url)}} >
                    <img className={"rightNavImg"} src={`${process.env.PUBLIC_URL}/assets/images/`+data['img']}/>
                    <p className={"rightNavTex"}>{data['title']}</p>
                </div>
            );
        })
    }
}



export default withRouter(RightNav);
